import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.updateHeader();
    window.addEventListener('scroll', () => this.updateHeader());
  }

  disconnect() {
    window.removeEventListener('scroll', () => this.updateHeader());
  }

  updateHeader() {
    var logo = document.getElementById('logo');
    let header = document.getElementById('header');
    let link = document.getElementById('listMainHeader');
    let botton = document.getElementById('bottonOnHeader');
    let iconNavbar = document.getElementById('iconNavbar');
    if (window.pageYOffset > 50) {
      header.classList.add('bg-white', 'shadow');
      link.classList.remove('md:text-white');
      link.classList.add('md:text-green-700', 'border-none', 'shadow-none');
      iconNavbar.classList.add('text-green-700');
      iconNavbar.classList.remove('text-white');
      botton.classList.remove('md:text-white');
      botton.classList.add('md:text-green-700');
      logo.src = logo.getAttribute('normal')
    } else {
      header.classList.remove('bg-white', 'shadow');
      link.classList.remove('md:text-green-700');
      link.classList.add('md:text-white');
      iconNavbar.classList.remove('text-green-700');
      iconNavbar.classList.add('text-white');
      botton.classList.remove('md:text-green-700');
      botton.classList.add('md:text-white');
      logo.src = logo.getAttribute('white')
    }
  }

  scrollToSection(event) {
    event.preventDefault();
    const sectionId = event.currentTarget.getAttribute("data-section-name");

    if (window.location.pathname !== '/' && sectionId == 'contacts') {
      window.location.href = `/#${sectionId}`; // Redirige a /home y luego hace scroll
    } else {
      const section = document.getElementById(sectionId);
      const offsetTop = section.offsetTop;
      window.scrollTo({
        top: offsetTop,
        behavior: "smooth"
      });
    }
  }
}
